import { SET_FLASH } from '../actions';
export default function (state = {}, action) {
  switch (action.type) {
  case SET_FLASH: {
    return {
      ...state,
      flash: {
        message: action.payload.message,
        show: !!action.payload.message,
        variant: action.payload.variant || 'success'
      }
    };
  }
  default: {
    return state;
  }
  }
}

